import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import OrganisationSelect from 'view/component/form-items/organisation-select'
import buildOrganisations from 'helper/build-organisations'

const CategoryOrgSelect = ({ organisations }) => {
  return (
    <OrganisationSelect organisations={organisations} />
  )
}

CategoryOrgSelect.propTypes = {
  organisations: PropTypes.array
}

const mapStateToProps = ({ organisation, category }, { categoryUuid }) => ({
  organisations: categoryUuid
    ? buildOrganisations(organisation.organisations, category.categories, categoryUuid)
    : organisation.organisations
})

export default connect(mapStateToProps)(CategoryOrgSelect)
